export default __webpack_public_path__ + "static/media/browser.ec326752.svg";